export enum SearchEntity {
  TITLE_TEMPLATE = 'titleTemplate',
  TITLE_ORDER = 'titleOrder',
  PROJECT = 'project',
  BUSINESS_RECORD = 'businessRecord'
}
